import PropTypes from "prop-types"
import { Flex, Tooltip, theme } from "antd"
import { UserOutlined, FilePdfOutlined } from "@ant-design/icons"
import { DollarSign } from "ui/Icon/DSIcon/DollarSign"
import TicketTypeIcon from "../BookingTable/TicketTypeIcon"
import BookingTag from "../BookingTag"
import { PAYMENT_COLOR, PAYMENT_LABEL, DOLLAR_STROKE_TOKEN } from "../BookingTable/constants"
import styles from "./UpcomingCard.module.css"

const PaymentDollar = ({ paymentStatus }) => {
  const { token } = theme.useToken()
  const color = PAYMENT_COLOR[paymentStatus] ?? "error"
  const label = PAYMENT_LABEL[paymentStatus] ?? "Payment Failed"
  return (
    <Tooltip title={label}>
      <span>
        <BookingTag color={color} className={styles.paymentTag}>
          <DollarSign stroke={token[DOLLAR_STROKE_TOKEN[color]]} />
        </BookingTag>
      </span>
    </Tooltip>
  )
}

PaymentDollar.propTypes = {
  paymentStatus: PropTypes.string
}

// Mobile card for a Upcoming Experience row. Tapping the body opens the detail;
// the ⋯ button opens the Actions bottom sheet (View Details / Open Actions Queue).
const UpcomingCard = ({ item, onOpenActions }) => (
  <div className={styles.card}>
    <Flex justify="space-between" align="flex-start" gap={8}>
      <button type="button" className={styles.body} onClick={() => onOpenActions(item)}>
        <Flex align="center" gap={8} className={styles.idRow}>
          <TicketTypeIcon isGroup={item.experienceIsGroup} />
          <span className={styles.bookingId}>{item.bookingId}</span>
          <span className={styles.dateTime}>
            {[item.experienceDate, item.experienceTime].filter(Boolean).join(" · ")}
          </span>
        </Flex>
        <span className={styles.title} title={item.tripTitle}>
          {item.tripTitle}
        </span>
        <Flex align="center" gap={10} className={styles.meta}>
          <Flex align="center" gap={4}>
            <UserOutlined className={styles.metaIcon} />
            <span className={styles.guestCount}>{item.totalGuestCount}</span>
          </Flex>
          <PaymentDollar paymentStatus={item.paymentStatus} />
          {item.isWaiverAttached && (
            <BookingTag color={item.docsSign >= item.docsTotal ? "success" : "error"} className={styles.docsTag}>
              <Flex align="center" gap={4}>
                <FilePdfOutlined />
                {item.docsSign}/{item.docsTotal}
              </Flex>
            </BookingTag>
          )}
        </Flex>
      </button>
      <button type="button" className={styles.moreBtn} onClick={() => onOpenActions(item)} aria-label="Actions">
        <span className={styles.moreDots}>⋯</span>
      </button>
    </Flex>
  </div>
)

UpcomingCard.propTypes = {
  item: PropTypes.shape({
    uuid: PropTypes.string,
    groupId: PropTypes.string,
    bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tripTitle: PropTypes.string,
    experienceDate: PropTypes.string,
    experienceTime: PropTypes.string,
    experienceIsGroup: PropTypes.bool,
    totalGuestCount: PropTypes.number,
    paymentStatus: PropTypes.string,
    isWaiverAttached: PropTypes.bool,
    docsSign: PropTypes.number,
    docsTotal: PropTypes.number
  }).isRequired,
  onOpenActions: PropTypes.func.isRequired
}

export default UpcomingCard
